bcn.tabs = (function () {

  'use strict';

  function setActiveTab () {

    $('[data-tabs] li').on('click', function () {
      $(this).addClass('active')
        .siblings('li')
        .removeClass('active');
    });
  }

  return {
    init: function () {
      $('.donation .tabs--small').css('display', 'flex');
      setActiveTab();
    }
  };

})();
